// extracted by mini-css-extract-plugin
export default {"container":"detail_container__Ey+R7","table":"detail_table__mDGD5","d-flex":"detail_d-flex__LcFjg"};